import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFullscreen1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFullscreen1"><Path d="M4 14V18H8V20H2V14H4ZM22 14V20H16V18H20V14H22ZM8 4V6H4V10H2V4H8ZM22 4V10H20V6H16V4H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFullscreen1;
